// TODO: resolve CHCP disables by bot
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable sonarjs/no-duplicate-string */
export const SERVICE_CONSUMER_CODE = '1000';

export const MAXIMUM_TINS_PER_USER = 50;
export const MAXIMUM_DELEGATES_PER_TIN = 15;

export const JOB_ROLE_DELEGATE_NAME = 'Delegation access and views';
export const COLLABORATIVE_CARE_ENTITLEMENT = 'Collaborative care';
export const CLAIM_STATUS_NOTIFICATIONS = 'Claim status notifications';
export const MHK_VIEW_ENTITLEMENT =
  'Medicare Advantage Precertification View Only';
export const MHK_SUBMIT_ENTITLEMENT =
  'Medicare Advantage Precertification Submit Request';
export const EFT_ENTITLEMENT_ROLE_NAME = 'Enroll and manage EFT';

export enum SELECTED_USER_TYPE {
  new = 'new',
  exisiting = 'existing',
}

export enum USER_STATUS {
  vetting_am = 'VETTING_AM',
  vetting_cigna = 'VETTING_CIGNA',
  vetting_fed = 'VETTING_FED',
  vetted_partially_am = 'VETTED_PARTIALLY_AM',
  vetting_partially_cigna = 'VETTING_PARTIALLY_CIGNA',
  vetting_partially_fed = 'VETTING_PARTIALLY_FED',
  validated_am = 'VALIDATED_AM',
  validated_cigna = 'VALIDATED_CIGNA',
  validated_fed = 'VALIDATED_FED',
}

export enum TIN_STATUS {
  assigned = 'assigned',
  unassigned = 'un assigned',
}

export enum PAGE_SCREEN {
  overview = 'overview',
  identify = 'identify',
  assign = 'assign',
  access = 'access',
  interstitial = 'interstitial',
  confirm = 'confirm',
  receive = 'receive',
}

export const PAGE_STEPS_WITHOUT_PREF_LOB = [
  'Identify Users',
  'How Do You Want to Assign Access',
  'Assign TIN & Levels of Access',
  'Confirm Entitlements',
  'Receive Credentials',
];

export const PAGE_STEPS = [
  'Identify Users',
  'How Do You Want to Assign Access',
  'Assign TIN & Levels of Access',
  'Confirm Entitlements',
  'Confirm Line of Business',
  'Receive Credentials',
];

export const PAGE_STEPS_WITH_ONE_CONFIRMATION = [
  'Identify Users',
  'How Do You Want to Assign Access',
  'Assign TIN & Levels of Access',
  'Confirmation',
  'Receive Credentials',
];

export enum ADOBE_TRACK_NAMES {
  overview = 'Manage User Access',
  identify = 'Identify Users',
  assign = 'How Do You Want to Assign Access',
  access = 'Assign TIN & Levels of access',
  interstitial = 'interstitial',
  confirm = 'Confirm',
  receive = 'Receive Credentials',
}

export enum FILTER_GROUP {
  all = 'all',
  awaiting = 'awaiting approval',
}

export enum USER_LOADING_STAGE {
  loading = 'loading',
  loaded_pending = 'loaded pending users',
  loaded_all = 'loaded all users',
  error = 'error',
}

export enum ASSIGNMENT_METHOD {
  individual = 'individual',
  bulk = 'bulk',
}
